import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import AvisoEmpendenciaSnackbar from "./AvisoEmpendenciaSnackbar";
import Footer from "./Footer";
import Navbar from "./Navbar";

function AppLayout() {
  const focarConteudoPrincipal = (event) => {
    event.preventDefault();
    const conteudoPrincipal = document.getElementById("conteudo-principal");
    if (!conteudoPrincipal) {
      return;
    }
    conteudoPrincipal.focus();
    if (typeof conteudoPrincipal.scrollIntoView === "function") {
      conteudoPrincipal.scrollIntoView();
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
      }}
    >
      <Box
        component="a"
        href="#conteudo-principal"
        onClick={focarConteudoPrincipal}
        sx={{
          position: "absolute",
          left: 16,
          top: 8,
          zIndex: (theme) => theme.zIndex.tooltip,
          px: 2,
          py: 1,
          borderRadius: 1,
          fontWeight: 700,
          textDecoration: "none",
          bgcolor: "background.paper",
          color: "primary.main",
          boxShadow: 3,
          transform: "translateY(-200%)",
          "&:focus": {
            transform: "translateY(0)",
            outline: (theme) => `2px solid ${theme.palette.primary.main}`,
            outlineOffset: 2,
          },
        }}
      >
        Ir para o conteúdo
      </Box>
      <Navbar />
      <Box
        component="main"
        id="conteudo-principal"
        tabIndex={-1}
        sx={{ flex: 1, outline: "none" }}
      >
        <Outlet />
      </Box>
      <Footer />
      <AvisoEmpendenciaSnackbar />
    </Box>
  );
}

export default AppLayout;
